import { ReduxAction } from 'types/redux';
import * as appActions from 'actions/app/actionTypes';

const initState = {
  showGlobalModal: false,
  contentGlobalModal: null,
};

export default (state = initState, actions: ReduxAction) => {
  const { type, payload } = actions;
  switch (type) {
    case appActions.actionTypes.SHOW_GLOBAL_MODAL:
      return {
        ...state,
        showGlobalModal: true,
        contentGlobalModal: payload?.view,
      };
    case appActions.actionTypes.HIDE_GLOBAL_MODAL:
      return {
        ...state,
        showGlobalModal: false,
        contentGlobalModal: null,
      };

    default:
      return state;
  }
};
